var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-tabs',{on:{"input":value => {
                _vm.openOnce[value] = true
            }},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},_vm._l((_vm.tabs),function(tab){return _c('b-tab-item',{key:tab.index,attrs:{"label":tab.label,"disabled":tab.disabled}},[(_vm.openOnce[tab.index])?_c('writing-table-status',{attrs:{"status":tab.status}}):_vm._e()],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }